import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/tokyu-web/app/(pages)/[locale]/authentication/(simple-layout)/sign-in/SignIn.tsx");
